export default {
	"e872e57859137b9c84c27ff9c2230147": "促銷商品信息曝光",
	"2e559a40fe029a2702aeed075f3256df": "促銷商品詳情頁",
	"02720b8439d76730d67ea9cb43b756ee": "促銷商品詳情頁_SKU選擇抽屜",
	"40f43d921074fb0050380b9910a31fb6": "該商品暫時無法購買，請聯繫客服",
	"92a4ff217a99a6c97c0f9477856e8424": "商品詳情頁_SKU選擇抽屜_確定按鈕",
	"910cc2fc89535112bd266203330673dd": "商品詳情頁_SKU選擇抽屜",
	"8f77677f7d83d20616d63dfa5138f85a": "原價",
	"73795c41fdd34539c6b6d212d23434da": "商品為限購商品，您不滿足限購條件，無法購買",
	"53997ca1844bc56d2361c1da72e52a0e": "已下架",
	"036d62c422933dee566f3ecc15d9d7cc": "已售罄",
	"89b7c80030a72d3ba23cfa9e0c35278d": "立即購買",
	"eca3fb3bb9f6673181a8c1e1586bd32e": "登錄查看優惠",
	"0bcf854077294bb13c657aef880cc9a7": "0元簽約",
	"589b70dbda8407a46ccb11cf1c43c11c": "選擇商品",
	"2084df2c35a80a4c531debec35f87e51": "領券購買",
	"7d099309d4d95bc67e510882069e797f": "商品詳情頁_購買按鈕",
	"87de92da2b65bb09107389426c8469e1": "參數錯誤!",
	"2f5e2bb9287717ab4cf4d22be52459c2": "實際價格可能因國家/地區税率差異略有浮動,請以支付頁面為準",
	"047ca3c31efc5217d3c7febb7580a5e3": "先學後付",
	"d420c6711b060379f9b4fb379dc91547": "季付",
	"d672ee75696f853f98f954c65eab47dc": "分享",
	"a1473119c045c63c7cb34506501762cb": "配送",
	"29ea6e058ff28e2a3677734159ffe9ac": "快遞配送",
	"b8e4b0eb658162bfccbc2de7292f12ef": "説明",
	"c3a078a756214810b29b06fa3d6443f6": "商品詳情頁_客服按鈕",
	"cb865d32020146363bdb5c99a6e809bd": "客服"
}
